import dayjs from '@/js/libs/dayjs';
import { DATE_RANGE_SEPARATOR, ISO_DATE_FORMAT, ISO_DATETIME_FORMAT } from './constants';
export const isDefinedDateRange = (value) => value?.[0] instanceof Date && value?.[1] instanceof Date;
export const convertDateToTimezone = (date, showLocal, preserveTime) => {
    const d = dayjs(date);
    if (showLocal) {
        return preserveTime ? d.toDate() : d.startOf('day').toDate();
    }
    // Convert to UTC: extract calendar date/time and create as UTC
    const format = preserveTime ? ISO_DATETIME_FORMAT : ISO_DATE_FORMAT;
    const dateStr = d.format(format);
    return dayjs.utc(dateStr).toDate();
};
export const getValidDateRange = ({ value, dateFormatKey, showLocal, minDate, maxDate }) => {
    const [start, end] = value.split(DATE_RANGE_SEPARATOR).map((part) => part.trim());
    const startDate = dayjs(start, dateFormatKey, true);
    const endDate = dayjs(end, dateFormatKey, true);
    const min = dayjs(minDate).startOf('day');
    const max = dayjs(maxDate).startOf('day');
    const isValidDates = startDate.isValid() &&
        endDate.isValid() &&
        startDate.isSameOrBefore(endDate) &&
        (minDate ? startDate.isSameOrAfter(min) && endDate.isSameOrAfter(min) : true) &&
        (maxDate ? startDate.isSameOrBefore(max) && endDate.isSameOrBefore(max) : true);
    if (isValidDates) {
        return [convertDateToTimezone(startDate, showLocal), convertDateToTimezone(endDate, showLocal)];
    }
    return null;
};
export const getValidDate = ({ value, dateFormatKey, showLocal, minDate, maxDate }) => {
    if (!value)
        return null;
    const date = dayjs(value, dateFormatKey, true);
    const min = dayjs(minDate).startOf('day');
    const max = dayjs(maxDate).startOf('day');
    const hasTime = dateFormatKey.includes('HH') || dateFormatKey.includes('mm');
    if (date.isValid() && (minDate ? date.isSameOrAfter(min) : true) && (maxDate ? date.isSameOrBefore(max) : true)) {
        return convertDateToTimezone(date, showLocal, hasTime);
    }
    return null;
};
export const generateTimePresets = (intervals) => {
    const presets = [];
    const startTime = dayjs().startOf('day');
    const endTime = dayjs().endOf('day');
    for (let currentTime = startTime; currentTime.isBefore(endTime); currentTime = currentTime.add(intervals, 'minute')) {
        const preset = {
            title: currentTime.format('HH:mm'),
            value: currentTime.toDate(),
            isActive: (selected, current) => {
                if (!selected)
                    return false;
                const selectedDate = dayjs(selected);
                const currentDate = dayjs(current);
                return selectedDate.hour() === currentDate.hour() && selectedDate.minute() === currentDate.minute();
            },
        };
        presets.push(preset);
    }
    return presets;
};
export const toLocalDisplayDate = (date, showLocal) => {
    if (showLocal) {
        return dayjs(date).toDate();
    }
    const d = date instanceof Date ? date : date.toDate();
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
};
export const getDateArray = (value, showLocal) => {
    if (Array.isArray(value)) {
        const formattedStart = value[0] ? convertDateToTimezone(value[0], showLocal) : null;
        const formattedEnd = value[1] ? convertDateToTimezone(value[1], showLocal) : null;
        return [formattedStart, formattedEnd];
    }
    return [null, null];
};
